import { ASSETS_URL, ReviewProduct, ReviewType, VideoReview } from '../../types';
import subs from '@/static/assets/reviews/LeonelMiranda_Renters/subs.vtt';
import poster from '@/static/assets/reviews/LeonelMiranda_Renters/video.jpg';

export const LeonelMiranda: VideoReview = {
  type: ReviewType.Video,
  product: [ReviewProduct.Renters, ReviewProduct.All],
  reviewerName: 'Leonel',
  videoUrl: `${ASSETS_URL}/renters/LeonelMiranda_Renters.webm`,
  posterUrl: poster,
  captionsUrl: subs,
};
